import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=4c2471af&scoped=true&"
import script from "./Messenger.vue?vue&type=script&lang=js&"
export * from "./Messenger.vue?vue&type=script&lang=js&"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=4c2471af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2471af",
  null
  
)

export default component.exports